// permission: shown when the account holds any of these keys (same keys as the route meta)
export interface INavigationRoute {
  name: string
  displayName: string
  meta: { icon: string }
  permission?: string[]
  hideWith?: string[] // hidden when the account holds any of these (e.g. the affiliate portal for program managers)
  children?: INavigationRoute[]
}

const COURSES = ['courses.view', 'courses.view.own', 'courses.view.assigned']
const B2B_VIEW = ['b2b.view', 'b2b.view.assigned']

export default {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    {
      name: 'dashboard',
      displayName: 'menu.dashboard',
      meta: {
        icon: 'vuestic-iconset-dashboard',
      },
      permission: ['training.dashboard.view', ...COURSES],
    },
    {
      name: 'courses',
      displayName: 'menu.courses',
      meta: {
        icon: 'folder_shared',
      },
      permission: COURSES,
    },
    {
      name: 'commerce',
      displayName: 'menu.commerce',
      meta: { icon: 'storefront' },
      children: [
        {
          name: 'commerce-orders',
          displayName: 'menu.commerce-orders',
          meta: { icon: '' },
          permission: ['commerce.orders.view'],
        },
        {
          name: 'commerce-customers',
          displayName: 'menu.commerce-customers',
          meta: { icon: '' },
          permission: ['commerce.customers.view'],
        },
        {
          name: 'commerce-products',
          displayName: 'menu.commerce-products',
          meta: { icon: '' },
          permission: ['commerce.catalog.view'],
        },
        {
          name: 'commerce-categories',
          displayName: 'menu.commerce-categories',
          meta: { icon: '' },
          permission: ['commerce.catalog.manage'],
        },
        {
          name: 'commerce-articles',
          displayName: 'menu.commerce-articles',
          meta: { icon: '' },
          permission: ['commerce.articles.view'],
        },
        {
          name: 'commerce-promotions',
          displayName: 'menu.commerce-promotions',
          meta: { icon: '' },
          permission: ['commerce.promotions.view'],
        },
        {
          name: 'commerce-channels',
          displayName: 'menu.commerce-channels',
          meta: { icon: '' },
          permission: ['commerce.channels.view'],
        },
        {
          name: 'commerce-reports',
          displayName: 'menu.commerce-reports',
          meta: { icon: '' },
          permission: ['commerce.reports.view'],
        },
      ],
    },
    {
      name: 'warehouse',
      displayName: 'menu.warehouse',
      meta: { icon: 'warehouse' },
      children: [
        {
          name: 'warehouse-overview',
          displayName: 'menu.warehouse-overview',
          meta: { icon: '' },
          permission: ['warehouse.view'],
        },
        {
          name: 'warehouse-outbound',
          displayName: 'menu.warehouse-outbound',
          meta: { icon: '' },
          permission: ['warehouse.outbound.manage'],
        },
        {
          name: 'warehouse-returns',
          displayName: 'menu.warehouse-returns',
          meta: { icon: '' },
          permission: ['warehouse.returns.view'],
        },
        {
          name: 'warehouse-stock',
          displayName: 'menu.warehouse-stock',
          meta: { icon: '' },
          permission: ['warehouse.view'],
        },
        {
          name: 'warehouse-documents',
          displayName: 'menu.warehouse-documents',
          meta: { icon: '' },
          permission: ['warehouse.documents.view'],
        },
        {
          name: 'warehouse-stocktakes',
          displayName: 'menu.warehouse-stocktakes',
          meta: { icon: '' },
          permission: ['warehouse.stocktakes.manage'],
        },
        {
          name: 'warehouse-allocations',
          displayName: 'menu.warehouse-allocations',
          meta: { icon: '' },
          permission: ['warehouse.allocations.view'],
        },
        {
          name: 'warehouse-reports',
          displayName: 'menu.warehouse-reports',
          meta: { icon: '' },
          permission: ['warehouse.reports.view', 'warehouse.valuation.view'],
        },
        {
          name: 'warehouse-setup',
          displayName: 'menu.warehouse-setup',
          meta: { icon: '' },
          permission: ['warehouse.setup.manage', 'warehouse.suppliers.manage'],
        },
      ],
    },
    {
      name: 'b2b',
      displayName: 'menu.b2b',
      meta: { icon: 'store' },
      children: [
        {
          name: 'b2b-overview',
          displayName: 'menu.b2b-overview',
          meta: { icon: '' },
          permission: ['b2b.reports.view'],
        },
        {
          name: 'b2b-dealers',
          displayName: 'menu.b2b-dealers',
          meta: { icon: '' },
          permission: B2B_VIEW,
        },
        {
          name: 'b2b-orders',
          displayName: 'menu.b2b-orders',
          meta: { icon: '' },
          permission: B2B_VIEW,
        },
        {
          name: 'b2b-receipts',
          displayName: 'menu.b2b-receipts',
          meta: { icon: '' },
          permission: B2B_VIEW,
        },
        {
          name: 'b2b-aging',
          displayName: 'menu.b2b-aging',
          meta: { icon: '' },
          permission: ['b2b.reports.view'],
        },
        {
          name: 'b2b-tiers',
          displayName: 'menu.b2b-tiers',
          meta: { icon: '' },
          permission: ['b2b.pricing.manage'],
        },
      ],
    },
    {
      name: 'affiliate',
      displayName: 'menu.affiliate',
      meta: { icon: 'handshake' },
      children: [
        {
          name: 'affiliate-list',
          displayName: 'menu.affiliate-list',
          meta: { icon: '' },
          permission: ['affiliate.manage'],
        },
        {
          name: 'affiliate-tiers',
          displayName: 'menu.affiliate-tiers',
          meta: { icon: '' },
          permission: ['affiliate.manage'],
        },
        {
          name: 'affiliate-commissions',
          displayName: 'menu.affiliate-commissions',
          meta: { icon: '' },
          permission: ['affiliate.commissions.view'],
        },
        {
          name: 'affiliate-payouts',
          displayName: 'menu.affiliate-payouts',
          meta: { icon: '' },
          permission: ['affiliate.commissions.view'],
        },
      ],
    },
    {
      name: 'affiliate-me',
      displayName: 'menu.affiliate-me',
      meta: { icon: 'handshake' },
      permission: ['affiliate.self'],
      hideWith: ['affiliate.manage'],
    },
    {
      name: 'social',
      displayName: 'menu.social',
      meta: {
        icon: 'campaign',
      },
      children: [
        {
          name: 'social-calendar',
          displayName: 'menu.social-calendar',
          meta: { icon: '' },
          permission: ['social.access'],
        },
        {
          name: 'social-posts',
          displayName: 'menu.social-posts',
          meta: { icon: '' },
          permission: ['social.access'],
        },
        {
          name: 'social-analytics',
          displayName: 'menu.social-analytics',
          meta: { icon: '' },
          permission: ['social.access'],
        },
        {
          name: 'social-channels',
          displayName: 'menu.social-channels',
          meta: { icon: '' },
          permission: ['social.access'],
        },
      ],
    },
    {
      name: 'users',
      displayName: 'menu.users',
      meta: {
        icon: 'group',
      },
      permission: ['users.view', 'users.view.own'],
    },
    {
      name: 'access',
      displayName: 'menu.access',
      meta: { icon: 'admin_panel_settings' },
      permission: ['access.manage'],
    },
    {
      name: 'faq',
      displayName: 'menu.faq',
      meta: {
        icon: 'quiz',
      },
    },
    {
      name: 'settings',
      displayName: 'menu.settings',
      meta: {
        icon: 'settings',
      },
    },
  ] as INavigationRoute[],
}
